"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeEmail = normalizeEmail;
exports.isEmailIdentifier = isEmailIdentifier;
exports.normalizeEmailIdentifier = normalizeEmailIdentifier;
exports.isNeoTaxEmail = isNeoTaxEmail;
function normalizeEmail(email) {
    if (email === null) {
        return null;
    }
    return email.trim().toLowerCase();
}
/**
 * Whether a provider identifier carries an email address, and is therefore safe to case-normalize.
 *
 * An email address is a case-insensitive identifier: `Dev@Example.com` and `dev@example.com` reach
 * the same inbox and are the same person. Contributor matching already relies on that when it joins
 * ticketing users to payroll users by email, so identifiers are treated the same way.
 *
 * The test is `@`-presence rather than an email pattern, which keeps it expressible identically as
 * SQL `LIKE '%@%'`. `LowercaseEmailShapedTicketingPids1787356800000` normalized the already-stored
 * identifiers on that predicate, and the two have to agree exactly: a value the migration lowercased
 * but this function skips is stored lowercase while its incoming counterpart is not, which is the
 * mismatch the whole mechanism exists to prevent. A pattern also has to be written twice, once for
 * JavaScript and once for POSIX, and the two disagree on Unicode whitespace and on non-ASCII
 * addresses that this deliberately still normalizes.
 *
 * The cost is that a provider issuing two case-differing non-email tokens containing an `@` would
 * have them folded onto one identifier. No company in production holds such a pair — the migration's
 * pre-flight guard checks for exactly that and came back empty.
 */
function isEmailIdentifier(identifier) {
    return identifier !== null && identifier.includes('@');
}
function normalizeEmailIdentifier(identifier) {
    if (!isEmailIdentifier(identifier)) {
        return identifier;
    }
    return normalizeEmail(identifier);
}
/** Whether an address belongs to Neo.Tax staff rather than to a customer. Case-insensitive. */
function isNeoTaxEmail(email) {
    return normalizeEmail(email).endsWith('@neo.tax');
}
